module.exports = __webpack_public_path__ + "img/icon-24.a5e89e82.svg";